export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const INIT_DATA = 'INIT_DATA';
export const SET_DRIVERS = 'SET_DRIVERS';
export const SET_PROMOS = 'SET_PROMOS';
export const SET_ALL_CANCELED_ORDERS = 'SET_ALL_CANCELED_ORDERS';
export const CREATE_PROMO = 'CREATE_PROMO';
export const REMOVE_PROMO = 'REMOVE_PROMO';
export const SET_STOCK = 'SET_STOCK';
export const SET_USERS = 'SET_USERS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const UPDATE_STOCK = 'UPDATE_STOCK';
export const SET_FINANCES = 'SET_FINANCES';
export const SET_GLOBAL_FINANCES = 'SET_GLOBAL_FINANCES';
export const SET_SELECTION_FINANCE = 'SET_SELECTION_FINANCE';
export const SET_SUPPORT = 'SET_SUPPORT';
export const REMOVE_SUPPORT = 'REMOVE_SUPPORT';
export const UPDATE_CASH = 'UPDATE_CASH';
export const SET_PUSH_NOTIF = 'SET_PUSH_NOTIF';
export const SEND_PUSH_NOTIF = 'SEND_PUSH_NOTIF';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_ALL_ORDERS = 'SET_ALL_ORDERS';
export const SET_ORDERS_PAST = 'SET_ORDERS_PAST';
export const SET_FINISH_ORDERS = 'SET_FINISH_ORDERS';
export const SET_ALL_PAST_ORDERS = 'SET_ALL_PAST_ORDERS';
export const SET_ORDERS_CANCELED = 'SET_ORDERS_CANCELED';
export const CHANGE_AVAILABLE = 'CHANGE_AVAILABLE';
export const SET_STRIPE_DATA = 'GET_STRIPE_DATA';
export const SET_FIREBASE = 'SET_FIREBASE';
export const SET_MENU_DATA = 'SET_MENU_DATA';
export const SET_SELECTION_FINANCE_ENTITY = 'SET_SELECTION_FINANCE_ENTITY';
export const OPEN_ERROR_MODAL = 'OPEN_ERROR_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL';
export const SET_PAGE = 'SET_PAGE';
export const INIT_PAGE = 'INIT_PAGE';
export const RESET_REALTIME_DB = 'RESET_REALTIME_DB';
export const RESET_ORDERS = 'RESET_ORDERS';
export const RESET_FINANCE = 'RESET_FINANCE';
export const RESET_USER_DATA = 'RESET_USER_DATA';
export const SET_ROWS_PER_PAGE = 'CLOSE_SET_ROWS_PER_PAGEERROR_MODAL';
export const REFUND_ORDER = 'REFUND_ORDER';
export const INIT_SIDEBAR = 'INIT_SIDEBAR';
export const CHANGE_ACTIVE_SIDEBAR_ITEM = 'CHANGE_ACTIVE_SIDEBAR_ITEM';
export const SHOW_SIDEBAR_COLLAPSE = 'SHOW_SIDEBAR_COLLAPSE';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
// Component types
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_HELP_MODAL = 'SHOW_HELP_MODAL';
export const SET_MENU_REALTIME = 'SET_MENU_REALTIME';
